module.exports = __webpack_public_path__ + "img/qr-code-stage1.b33fda76.png";